<template lang="pug">
.text-red-600.ml-1.mt-1(v-if="error") * {{ error }}
</template>

<script setup>
  const props = defineProps({
    error:     { type: String, default: undefined },
  })
</script>
